/* Product discussions use public reads and explicit, session-authenticated NodeBB writes. */
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    function boot() { document.querySelectorAll('[data-pg-product-community]').forEach(function (root) { api.mount(root, window); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }
})(function () {
  'use strict';
  var FORUM = 'https://community.pixelgipfel.ch';
  var SHOP = 'https://pixelgipfel.ch';
  var BRIDGE = 'https://api.pixelgipfel.ch';
  function problem(code) { var error = new Error(code); error.code = code; return error; }
  function positive(value) { return /^[1-9]\d{0,14}$/.test(String(value || '')) ? String(value) : null; }
  function productTag(value) { return /^[1-9]\d{1,13}$/.test(String(value || '')) ? 'p' + value : null; }
  function productPath(value) {
    if (typeof value !== 'string' || value.length > 2048 || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2,4})?\/)?products\//.test(value)) return null;
    try {
      var decoded = decodeURIComponent(value);
      if (/[\s\\?#%\u0000-\u001f\u007f]/u.test(decoded) || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2,4})?\/)?products\/[\p{L}\p{M}\p{N}_™®-]+\/?$/u.test(decoded)) return null;
      var canonical = new URL(decoded, SHOP).pathname;
      return canonical.length <= 2048 ? canonical : null;
    } catch (_error) { return null; }
  }
  function plainText(value) {
    return String(value || '').replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, '')
      .replace(/<br\s*\/?\s*>|<\/(?:p|div|li|h[1-6])\s*>/gi, '\n').replace(/<[^>]*>/g, '')
      .replace(/&(#x[0-9a-f]+|#\d+|amp|lt|gt|quot|apos|nbsp);/gi, function (entity, key) {
        var names = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' };
        if (key.charAt(0) !== '#') return names[key.toLowerCase()] || entity;
        var point = key.charAt(1).toLowerCase() === 'x' ? parseInt(key.slice(2), 16) : parseInt(key.slice(1), 10);
        return point > 31 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff) ? String.fromCodePoint(point) : '';
      }).replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim();
  }
  function tagValues(tags) { return Array.isArray(tags) ? tags.map(function (tag) { return typeof tag === 'string' ? tag : tag && (tag.value || tag.name); }) : []; }
  function hidden(record) { return record.deleted === true || record.deleted === 1 || record.deleted === '1' || record.isDeleted === true; }
  function pageInfo(data, page) {
    if (!data.pagination || Number(data.pagination.currentPage) !== page) throw problem('invalid_response');
    var pages = Number(data.pagination.pageCount);
    return { next: Number.isInteger(pages) && page < pages && page < 100 ? page + 1 : null };
  }
  function timestamp(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 && number <= 8640000000000000 ? number : 0;
  }
  function replyCount(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number - 1 : 0;
  }
  function forumScore(value) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^-?\d+$/.test(value))) return null;
    var number = Number(value);
    return Number.isSafeInteger(number) ? number : null;
  }
  function normalizeTopic(topic, tag) {
    if (!topic || hidden(topic) || String(topic.cid) !== '2' || !positive(topic.tid) || !tagValues(topic.tags).includes(tag)) return null;
    return { id: String(topic.tid), title: plainText(topic.titleRaw || topic.title).slice(0, 255),
      kind: tagValues(topic.tags).includes('erfahrung') ? 'experience' : 'question',
      author: plainText(topic.user && (topic.user.displayname || topic.user.username)).slice(0, 80),
      excerpt: plainText(topic.mainPost && topic.mainPost.content).slice(0, 350),
      replies: replyCount(topic.postcount),
      timestamp: timestamp(topic.timestamp), locked: topic.locked === true || topic.locked === 1 || topic.locked === '1',
      url: FORUM + '/topic/' + topic.tid };
  }
  function markdownText(value) { return String(value || '').replace(/[\r\n]+/g, ' ').replace(/[\\`*_{}\[\]()<>!#|]/g, '\\$&'); }
  function contentForProduct(context, body, variant) {
    var path = productPath(context.path);
    if (!path || !productTag(context.id)) throw problem('invalid_product');
    var variantId = variant && positive(variant.id);
    var link = SHOP + path + (variantId ? '?variant=' + variantId : '');
    return body.trim() + '\n\n---\n[' + markdownText(context.title) + '](' + link + ')' +
      (variant && variant.label ? '\n' + markdownText(variant.label).slice(0, 300) : '');
  }
  function validateDraft(draft) {
    if (!draft || !['question', 'experience'].includes(draft.kind) || typeof draft.title !== 'string' || draft.title.trim().length < 3 || draft.title.trim().length > 160) throw problem('invalid_title');
    if (typeof draft.body !== 'string' || draft.body.trim().length < 8 || draft.body.length > 10000) throw problem('invalid_body');
  }
  function bridgeUrl(value) {
    try {
      var url = new URL(value);
      if (url.origin !== BRIDGE || url.pathname !== '/customer/sso' || url.username || url.password || !/^\d+$/.test(url.searchParams.get('customer_id') || '') || !/^[a-f0-9]{22}$/.test(url.searchParams.get('token') || '')) return null;
      url.searchParams.delete('return'); return url.toString();
    } catch (_error) { return null; }
  }
  function abortable(operation, signal) {
    return new Promise(function (resolve, reject) {
      function aborted() { finish(reject, problem('cancelled')); }
      function finish(settle, value) {
        signal.removeEventListener('abort', aborted);
        settle(value);
      }
      signal.addEventListener('abort', aborted, { once: true });
      Promise.resolve(operation).then(function (value) { finish(resolve, value); }, function (error) { finish(reject, error); });
      if (signal.aborted) aborted();
    });
  }
  function createClient(win, context) {
    var tag = productTag(context.id);
    var session = win.pgForumSession;
    var version = session && session.logoutVersion();
    var invalidated = false;
    var busy = false;
    var uncertain = false;
    var writeController = null;
    function invalidate() { invalidated = true; if (writeController) writeController.abort(); }
    var unsubscribe = session ? session.onLogout(invalidate) : null;
    function validIdentity() {
      if (invalidated || !context.authenticated || !session || version !== session.logoutVersion()) throw problem('login_required');
    }
    async function request(path, options, signal, consume) {
      options = options || {};
      if (signal && signal.aborted) throw problem('cancelled');
      var controller = new win.AbortController();
      function abort() { controller.abort(); }
      if (signal) signal.addEventListener('abort', abort, { once: true });
      var timeout = win.setTimeout(abort, 15000);
      try {
        var response = await abortable(win.fetch(path, Object.assign({ credentials: 'omit', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer' }, options, { signal: controller.signal })), controller.signal);
        if (controller.signal.aborted) throw problem('cancelled');
        return consume ? await abortable(consume(response), controller.signal) : response;
      } finally {
        win.clearTimeout(timeout);
        if (signal) signal.removeEventListener('abort', abort);
      }
    }
    async function read(path, signal) {
      return request(FORUM + path, null, signal, function (response) {
        if (!response.ok) throw problem('read_failed');
        return response.json();
      });
    }
    async function list(page, signal) {
      if (!tag || !Number.isInteger(page) || page < 1 || page > 100) throw problem('invalid_product');
      var data = await read('/api/tags/' + tag + '?cid=2&page=' + page, signal);
      if (data.tag !== tag || !Array.isArray(data.topics)) throw problem('invalid_response');
      var info = pageInfo(data, page);
      return { topics: data.topics.map(function (topic) { return normalizeTopic(topic, tag); }).filter(Boolean), next: info.next };
    }
    async function thread(id, page, signal, sort) {
      if (!positive(id) || !Number.isInteger(page) || page < 1 || page > 100) throw problem('invalid_topic');
      if (sort !== undefined && !['oldest_to_newest', 'newest_to_oldest', 'most_votes'].includes(sort)) throw problem('invalid_sort');
      var data = await read('/api/topic/' + id + '?page=' + page + (sort === undefined ? '' : '&sort=' + sort), signal);
      var topic = normalizeTopic(data, tag);
      if (!topic || topic.id !== String(id) || !Array.isArray(data.posts)) throw problem('invalid_topic');
      var info = pageInfo(data, page);
      var votesEnabled = ![true, 1, '1'].includes(data['reputation:disabled']);
      return { topic: topic, next: info.next, votesEnabled: votesEnabled, posts: data.posts.filter(function (post) { return post && !hidden(post) && positive(post.pid) && String(post.tid) === String(id); }).map(function (post) {
        return { id: String(post.pid), author: plainText(post.user && (post.user.displayname || post.user.username)).slice(0, 80),
          content: plainText(post.content), timestamp: timestamp(post.timestamp),
          score: forumScore(post.votes), original: String(post.pid) === String(data.mainPid), url: FORUM + '/post/' + post.pid,
          moderator: Boolean(post.user && (post.user.isAdmin === true || post.user.isMod === true)) };
      }) };
    }
    async function authenticate(signal) {
      validIdentity();
      var endpoint = bridgeUrl(context.ssoUrl);
      if (!endpoint) throw problem('login_required');
      await abortable(session.resetForum(signal), signal);
      validIdentity();
      var issued = await request(endpoint, { credentials: 'include' }, signal, function (response) {
        if (!response.ok) throw problem('login_required');
        return response.json();
      });
      if (!issued || issued.ok !== true) throw problem('login_required');
      validIdentity();
      // The session-sharing plugin deliberately excludes /api. Login is saved before its redirect.
      var bootstrap = await request(FORUM + '/category/2/hardware-fragen', { credentials: 'include', redirect: 'manual' }, signal);
      if (bootstrap.type !== 'opaqueredirect' && !bootstrap.ok) throw problem('login_required');
      var config = await request(FORUM + '/api/config', { credentials: 'include' }, signal, function (response) {
        if (!response.ok) throw problem('login_required');
        return response.json();
      });
      validIdentity();
      if (!config || config.loggedIn !== true || !positive(config.uid) || typeof config.csrf_token !== 'string' || !/^[a-zA-Z0-9_-]{20,512}$/.test(config.csrf_token)) throw problem('login_required');
      return config.csrf_token;
    }
    async function write(path, payload, reply) {
      if (busy) throw problem('busy');
      if (uncertain) throw problem('submit_uncertain');
      validIdentity();
      busy = true;
      writeController = new win.AbortController();
      var controller = writeController;
      var signal = writeController.signal;
      // Includes the native reset, whose requests are owned by the shared session helper.
      var lifetime = win.setTimeout(function () { controller.abort(); }, 60000);
      var sent = false;
      try {
        var csrf = await authenticate(signal);
        validIdentity();
        if (signal.aborted) throw problem('cancelled');
        sent = true;
        return await request(FORUM + path, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf }, body: JSON.stringify(payload) }, signal, async function (response) {
          if (response.status >= 400 && response.status < 500) { sent = false; throw problem(response.status === 401 || response.status === 403 ? 'login_required' : 'submit_error'); }
          if (!response.ok) throw problem('submit_uncertain');
          var data = await response.json();
          if (!data || !data.status || !['ok', 'accepted'].includes(data.status.code) || !data.response) throw problem('submit_uncertain');
          var result = data.response;
          if (result.queued === true) return { queued: true };
          if (response.status !== 200 || data.status.code !== 'ok' || !positive(reply ? result.pid : result.tid) || (reply && String(result.tid) !== path.split('/').pop())) throw problem('submit_uncertain');
          return { queued: false, id: String(reply ? result.pid : result.tid) };
        });
      } catch (error) {
        if (sent) { uncertain = true; throw problem('submit_uncertain'); }
        throw error;
      } finally { win.clearTimeout(lifetime); busy = false; writeController = null; }
    }
    function publish(draft) {
      validateDraft(draft);
      return write('/api/v3/topics', { cid: 2, title: draft.title.trim(), content: contentForProduct(context, draft.body, draft.variant), tags: [tag, draft.kind === 'experience' ? 'erfahrung' : 'frage'] }, false);
    }
    async function reply(id, body) {
      if (typeof body !== 'string' || body.trim().length < 8 || body.length > 10000) throw problem('invalid_body');
      // Validate public topic/product membership again immediately before allowing a reply.
      var record = await thread(id, 1);
      if (record.topic.locked) throw problem('submit_error');
      return write('/api/v3/topics/' + id, { content: body.trim() }, true);
    }
    return { list: list, thread: thread, publish: publish, reply: reply, invalidate: invalidate,
      destroy: function () { invalidate(); if (unsubscribe) unsubscribe(); }, forumUrl: FORUM + '/tags/' + tag };
  }

  function mount(root, win) {
    if (root.getAttribute('data-enhanced') === 'true') return;
    var doc = root.ownerDocument;
    var copy;
    try { copy = JSON.parse(root.querySelector('[data-pg-community-i18n]').textContent); } catch (_error) { return; }
    var context = { id: root.getAttribute('data-product-id'), title: root.getAttribute('data-product-title'), path: root.getAttribute('data-product-path'),
      authenticated: root.getAttribute('data-authenticated') === 'true', ssoUrl: root.getAttribute('data-sso-url') };
    if (!productTag(context.id) || !productPath(context.path) || typeof win.fetch !== 'function' || typeof win.AbortController !== 'function') return;
    function q(name) { return root.querySelector('[data-pg-community-' + name + ']'); }
    function text(key) { return typeof copy[key] === 'string' ? copy[key] : ''; }
    function element(tag, className, value) { var node = doc.createElement(tag); if (className) node.className = 'pg-product-community__' + className; if (value !== undefined) node.textContent = value; return node; }
    var client = createClient(win, context);
    var topics = [];
    var topicNodes = new Map();
    var replyFields = new Map();
    var restored = null;
    var restoredTopicsLoaded = false;
    var next = 1;
    var filter = 'all';
    var loading = false;
    var loaded = false;
    var listController;
    var threadControllers = new Set();
    var opener;
    var posting = false;
    var permanentlyDisabled = false;
    var form = q('form');
    var composer = q('composer');
    var publish = q('publish');
    var status = q('form-status');
    var questionOnly = root.getAttribute('data-question-only') === 'true';
    function composerKind(kind) {
      root.querySelectorAll('[data-pg-community-kind]').forEach(function (radio) { radio.checked = radio.value === kind; });
      var legacy = questionOnly && kind === 'experience';
      if (q('compose-heading')) q('compose-heading').textContent = text(legacy ? 'legacy_compose_title' : 'compose_title');
      if (q('legacy-draft')) q('legacy-draft').hidden = !legacy;
      if (publish) publish.textContent = text(legacy ? 'legacy_publish' : 'publish');
    }
    var list = q('list');
    var locale = root.getAttribute('data-locale') || 'de';
    function loginLink() {
      var gateway = root.getAttribute('data-gateway-path');
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/zum-forum$/.test(gateway || '')) gateway = '/pages/zum-forum';
      return gateway + '?product_return=' + encodeURIComponent(context.path);
    }
    var customerId;
    try { customerId = new URL(context.ssoUrl).searchParams.get('customer_id'); } catch (_error) { customerId = ''; }
    var draftKey = 'pg:product-draft:' + context.id;
    function saveDraft() {
      if (!customerId || !form) return true;
      var replies = {};
      replyFields.forEach(function (field, id) { if (field.value.trim()) replies[id] = field.value.slice(0, 10000); });
      if (Object.keys(replies).length > 5) return false;
      var selected = root.querySelector('[data-pg-community-kind]:checked');
      var data = { customer: customerId, product: context.id, expires: Date.now() + 30 * 60 * 1000,
        title: q('title').value.slice(0, 160), body: q('body').value.slice(0, 10000), kind: selected && selected.value, replies: replies };
      try { win.sessionStorage.setItem(draftKey, JSON.stringify(data)); return true; } catch (_error) { return false; }
    }
    function addLogin(parent) {
      var link = element('a', 'text-link', text('sign_in_reply')); link.href = loginLink();
      var warned = false;
      link.addEventListener('click', function (event) {
        // Save only on an explicit sign-in action, in this tab and for this exact customer/product.
        if (!saveDraft() && !warned) { event.preventDefault(); warned = true; parent.appendChild(element('p', 'form-status', text('draft_not_saved'))); }
      });
      parent.appendChild(link);
    }
    function timestamp(value) { try { return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(new Date(value)); } catch (_error) { return ''; } }
    function errorMessage(error) { return text(error.code === 'login_required' ? 'session_expired' : error.code === 'submit_uncertain' ? 'submit_uncertain' : error.code === 'invalid_title' ? 'invalid_title' : error.code === 'invalid_body' ? 'invalid_body' : 'submit_error'); }
    root.setAttribute('data-enhanced', 'true');
    q('forum').href = client.forumUrl;
    if (publish) publish.disabled = false;
    if (form && customerId) {
      try {
        var saved = win.sessionStorage.getItem(draftKey);
        if (saved) {
          win.sessionStorage.removeItem(draftKey);
          var parsed = JSON.parse(saved);
          if (parsed.customer === customerId && parsed.product === context.id && parsed.expires > Date.now() && parsed.expires <= Date.now() + 30 * 60 * 1000 && typeof parsed.title === 'string' && typeof parsed.body === 'string' && ['question', 'experience'].includes(parsed.kind) && parsed.replies && typeof parsed.replies === 'object') {
            restored = parsed;
            q('title').value = parsed.title.slice(0, 160); q('body').value = parsed.body.slice(0, 10000);
            composerKind(parsed.kind);
            if (parsed.title || parsed.body) {
              composer.hidden = false; status.textContent = text('draft_saved');
              root.querySelectorAll('[data-pg-community-open]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
            }
          }
        }
      } catch (_error) { /* Draft persistence is optional, never an authentication mechanism. */ }
    }
    if (form && !restored) {
      try {
        var intentKey = 'pg:product-intent:' + context.id;
        var intent = JSON.parse(win.sessionStorage.getItem(intentKey) || 'null');
        win.sessionStorage.removeItem(intentKey);
        if (intent && intent.expires > Date.now() && intent.expires <= Date.now() + 10 * 60 * 1000 && ['question', 'experience'].includes(intent.kind) && (!questionOnly || intent.kind === 'question')) {
          composer.hidden = false;
          composerKind(intent.kind);
          root.querySelectorAll('[data-pg-community-open]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
        }
      } catch (_error) { /* The product return still works if session storage is unavailable. */ }
    }
    function replyForm(topic, parent, refresh) {
      if (topic.locked) return;
      if (!context.authenticated) { addLogin(parent); return; }
      var replyFormNode = element('form', 'reply-form');
      var label = element('label', 'label', text('reply_label'));
      var field = element('textarea', 'textarea');
      field.id = 'pg-community-reply-' + topic.id; label.htmlFor = field.id;
      field.required = true; field.minLength = 8; field.maxLength = 10000; field.rows = 3; field.placeholder = text('reply_placeholder');
      if (restored && typeof restored.replies[topic.id] === 'string') field.value = restored.replies[topic.id].slice(0, 10000);
      replyFields.set(topic.id, field);
      var button = element('button', 'submit', text('reply_publish')); button.type = 'submit';
      var replyStatus = element('p', 'form-status'); replyStatus.setAttribute('role', 'status');
      replyFormNode.append(label, field, button, replyStatus);
      replyFormNode.addEventListener('submit', async function (event) {
        event.preventDefault(); if (posting || permanentlyDisabled || !replyFormNode.reportValidity()) return;
        var submittedBody = field.value;
        posting = true; button.disabled = true; field.readOnly = true; replyStatus.textContent = text('reply_publishing');
        try {
          var result = await client.reply(topic.id, submittedBody);
          if (field.value === submittedBody) field.value = '';
          replyStatus.textContent = text(result.queued ? 'reply_queued' : 'reply_published');
          if (!result.queued) await refresh();
        } catch (error) {
          replyStatus.textContent = errorMessage(error);
          if (error.code === 'login_required') { permanentlyDisabled = true; addLogin(replyStatus); }
          if (error.code === 'submit_uncertain') permanentlyDisabled = true;
        } finally { posting = false; button.disabled = permanentlyDisabled; field.readOnly = false; }
      });
      parent.appendChild(replyFormNode);
    }
    function renderTopic(topic) {
      var article = element('article', 'thread'); article.setAttribute('role', 'listitem');
      var meta = element('div', 'thread-meta');
      var kind = element('span', 'type', text(topic.kind === 'experience' ? 'type_experience' : 'type_question')); kind.setAttribute('data-kind', topic.kind);
      meta.append(kind, element('span', '', topic.author));
      if (topic.timestamp) { var time = element('time', '', timestamp(topic.timestamp)); time.dateTime = new Date(topic.timestamp).toISOString(); meta.appendChild(time); }
      var heading = element('h3', 'thread-title');
      var toggle = element('button', 'thread-toggle', topic.title); toggle.type = 'button'; toggle.setAttribute('aria-expanded', 'false');
      var panel = element('div', 'replies'); panel.id = 'pg-community-thread-' + topic.id; panel.hidden = true; toggle.setAttribute('aria-controls', panel.id); heading.appendChild(toggle);
      var excerpt = element('p', 'excerpt', topic.excerpt);
      var foot = element('div', 'thread-foot');
      var replyCount = element('span', '', topic.replies + ' ' + text(topic.replies === 1 ? 'replies_one' : 'replies_label')); foot.appendChild(replyCount);
      var full = element('a', 'text-link', text('open_topic')); full.href = topic.url; foot.appendChild(full);
      var posts = element('div', 'posts');
      var tools = element('div', 'reply-tools'); tools.hidden = true;
      var sortLabel = element('label', 'sort-label', text('sort_label'));
      var sortSelect = element('select', 'sort'); sortSelect.id = 'pg-community-sort-' + topic.id; sortLabel.htmlFor = sortSelect.id;
      var helpfulOption;
      [['oldest_to_newest', 'sort_oldest'], ['newest_to_oldest', 'sort_newest'], ['most_votes', 'sort_helpful']].forEach(function (entry) {
        var option = element('option', '', text(entry[1])); option.value = entry[0]; option.setAttribute('value', entry[0]); sortSelect.appendChild(option);
        if (entry[0] === 'most_votes') helpfulOption = option;
      });
      sortSelect.value = 'oldest_to_newest'; tools.append(sortLabel, sortSelect);
      var voteNote = element('p', 'vote-note', text('vote_note')); voteNote.hidden = true;
      var threadStatus = element('p', 'reply-status'); threadStatus.setAttribute('role', 'status');
      var more = element('button', 'small-button', text('load_more_replies')); more.type = 'button'; more.hidden = true;
      more.setAttribute('data-pg-community-thread-more', '');
      var retry = element('button', 'small-button', text('load_replies_retry')); retry.type = 'button'; retry.hidden = true;
      retry.setAttribute('data-pg-community-thread-retry', '');
      panel.append(tools, posts, voteNote, threadStatus, more, retry);
      var threadLoaded = false; var threadBusy = false; var page = 1; var seenPosts = new Set(); var replyAttached = false;
      var sortOrder = 'oldest_to_newest'; var requestVersion = 0; var threadController; var retryRequest;
      async function loadPosts(reset, requestedSort) {
        if (threadBusy && !reset) return;
        requestedSort = requestedSort || sortOrder;
        var version = ++requestVersion;
        if (threadController) threadController.abort();
        var controller = new win.AbortController(); threadController = controller; threadControllers.add(controller);
        threadBusy = true; more.disabled = true; retry.hidden = true; threadStatus.textContent = text('loading_replies');
        var requestedPage = reset ? 1 : page;
        try {
          var result = await client.thread(topic.id, requestedPage, controller.signal, requestedSort);
          if (version !== requestVersion || controller.signal.aborted) return;
          helpfulOption.disabled = !result.votesEnabled;
          if (!result.votesEnabled && requestedSort === 'most_votes') return await loadPosts(true, 'oldest_to_newest');
          if (reset) { posts.replaceChildren(); seenPosts.clear(); }
          result.posts.forEach(function (post) {
            if (seenPosts.has(post.id)) return; seenPosts.add(post.id);
            var item = element('article', 'reply'); var byline = element('div', 'reply-meta', post.author);
            if (post.original) { item.className += ' pg-product-community__reply--original'; byline.appendChild(element('span', 'original-label', text('original_post'))); }
            if (post.moderator) byline.appendChild(element('span', 'type', text('moderator')));
            if (post.timestamp) byline.appendChild(element('span', '', timestamp(post.timestamp)));
            item.append(byline, element('div', 'reply-body', post.content));
            if (!post.original && result.votesEnabled) {
              var voteFoot = element('div', 'vote-foot');
              if (post.score !== null) voteFoot.appendChild(element('span', 'vote-score', text('vote_score').replace(/\{\{\s*count\s*\}\}/g, String(post.score))));
              var voteLink = element('a', 'vote-link', text('vote_in_forum')); voteLink.href = post.url; voteFoot.appendChild(voteLink); item.appendChild(voteFoot);
            }
            posts.appendChild(item);
          });
          sortOrder = requestedSort; sortSelect.value = requestedSort; tools.hidden = false; voteNote.hidden = !result.votesEnabled;
          page = result.next; threadLoaded = true; more.hidden = !page; threadStatus.textContent = '';
          if (!replyAttached) { replyForm(result.topic, panel, function () { return loadPosts(true); }); replyAttached = true; }
        } catch (_error) {
          if (version !== requestVersion || controller.signal.aborted) return;
          sortSelect.value = sortOrder; retryRequest = { reset: reset, sort: requestedSort };
          threadStatus.textContent = text('load_replies_error'); retry.hidden = false;
        } finally {
          threadControllers.delete(controller);
          if (version === requestVersion) { threadBusy = false; more.disabled = false; }
        }
      }
      toggle.addEventListener('click', function () {
        panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); excerpt.hidden = !panel.hidden;
        if (!panel.hidden && !threadLoaded) loadPosts(false);
      });
      sortSelect.addEventListener('change', function () { loadPosts(true, sortSelect.value); });
      more.addEventListener('click', function () { loadPosts(false); }); retry.addEventListener('click', function () { loadPosts(retryRequest ? retryRequest.reset : !threadLoaded, retryRequest && retryRequest.sort); });
      article.append(meta, heading, excerpt, foot, panel);
      article.pgUpdate = function (updated) {
        topic = updated; toggle.textContent = topic.title;
        replyCount.textContent = topic.replies + ' ' + text(topic.replies === 1 ? 'replies_one' : 'replies_label');
      };
      if (restored && typeof restored.replies[topic.id] === 'string') { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); excerpt.hidden = true; loadPosts(false); }
      return article;
    }
    function render() {
      var visible = topics.filter(function (topic) { return filter === 'all' || topic.kind === filter; });
      list.replaceChildren(); visible.forEach(function (topic) {
        var node = topicNodes.get(topic.id);
        if (!node) { node = renderTopic(topic); topicNodes.set(topic.id, node); } else node.pgUpdate(topic);
        list.appendChild(node);
      });
      q('empty').hidden = !loaded || visible.length !== 0;
      var key = filter === 'question' ? 'empty_questions_' : filter === 'experience' ? 'empty_experiences_' : 'empty_';
      q('empty-title').textContent = text(key + 'title'); q('empty-text').textContent = text(key + 'text');
      if (next && filter !== 'all' && visible.length === 0) { q('empty-title').textContent = text('empty_loaded'); q('empty-text').textContent = text('more'); }
      q('more').hidden = !next || !loaded;
      q('status').textContent = loaded ? text('results_loaded').replace(/\{\{\s*count\s*\}\}/g, String(visible.length)) : '';
    }
    async function loadTopics(reset) {
      if (loading) return;
      loading = true; q('error').hidden = true; q('more').disabled = true;
      if (!loaded) q('loading').hidden = false;
      listController = new win.AbortController();
      try {
        var result = await client.list(reset ? 1 : next, listController.signal);
        if (reset) topics = [];
        result.topics.forEach(function (topic) { if (!topics.some(function (existing) { return existing.id === topic.id; })) topics.push(topic); });
        if (restored && !restoredTopicsLoaded) {
          restoredTopicsLoaded = true;
          var ids = Object.keys(restored.replies).filter(function (id) { return positive(id) && typeof restored.replies[id] === 'string'; }).slice(0, 5);
          await Promise.all(ids.map(async function (id) {
            if (topics.some(function (topic) { return topic.id === id; })) return;
            try { var result = await client.thread(id, 1, listController.signal); topics.push(result.topic); } catch (_error) { /* Deleted or no-longer-public discussions stay hidden. */ }
          }));
        }
        next = result.next; loaded = true; render();
      } catch (_error) { q('error').hidden = false; q('empty').hidden = true; }
      finally { loading = false; q('loading').hidden = true; q('more').disabled = false; }
    }
    root.querySelectorAll('[data-pg-community-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        filter = button.getAttribute('data-pg-community-filter');
        root.querySelectorAll('[data-pg-community-filter]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        render();
      });
    });
    q('retry').addEventListener('click', function () { loadTopics(!loaded); }); q('more').addEventListener('click', function () { loadTopics(false); });
    root.querySelectorAll('[data-pg-community-open]').forEach(function (button) {
      if (!context.authenticated) {
        button.href = loginLink();
        button.addEventListener('click', function () {
          try { win.sessionStorage.setItem('pg:product-intent:' + context.id, JSON.stringify({ kind: button.getAttribute('data-pg-community-open'), expires: Date.now() + 10 * 60 * 1000 })); } catch (_error) {}
        });
        return;
      }
      button.addEventListener('click', function () {
        opener = button; composer.hidden = false;
        root.querySelectorAll('[data-pg-community-open]').forEach(function (item) { item.setAttribute('aria-expanded', 'true'); });
        var kind = button.getAttribute('data-pg-community-open'); composerKind(kind); q('title').focus();
      });
    });
    if (form) {
      q('compose-close').addEventListener('click', function () {
        composer.hidden = true;
        root.querySelectorAll('[data-pg-community-open]').forEach(function (item) { item.setAttribute('aria-expanded', 'false'); });
        if (opener) opener.focus();
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault(); if (posting || permanentlyDisabled || !form.reportValidity()) return;
        var submittedTitle = q('title').value; var submittedBody = q('body').value;
        posting = true; publish.disabled = true; q('title').readOnly = true; q('body').readOnly = true; status.textContent = text('publishing');
        root.querySelectorAll('[data-pg-community-kind]').forEach(function (radio) { radio.disabled = true; });
        try {
          var selected = root.querySelector('[data-pg-community-kind]:checked');
          var result = await client.publish({ title: submittedTitle, body: submittedBody, kind: selected && selected.value,
            variant: { id: q('variant-id').value, label: q('variant-label').textContent } });
          if (q('title').value === submittedTitle) q('title').value = '';
          if (q('body').value === submittedBody) q('body').value = '';
          status.textContent = text(result.queued ? 'queued' : 'published');
          if (!result.queued) await loadTopics(true);
        } catch (error) {
          status.textContent = errorMessage(error);
          if (error.code === 'login_required') { permanentlyDisabled = true; addLogin(status); }
          if (error.code === 'submit_uncertain') permanentlyDisabled = true;
        } finally {
          posting = false; publish.disabled = permanentlyDisabled; q('title').readOnly = false; q('body').readOnly = false;
          root.querySelectorAll('[data-pg-community-kind]').forEach(function (radio) { radio.disabled = false; });
        }
      });
      doc.addEventListener('pg:variant-changed', function (event) {
        if (!event.detail) return; q('variant-id').value = positive(event.detail.id) || '';
        q('variant-label').textContent = event.detail.variantTitle && event.detail.variantTitle !== 'Default Title' ? event.detail.variantTitle : text('variant_all');
      });
    }
    win.addEventListener('pagehide', function () { if (listController) listController.abort(); threadControllers.forEach(function (controller) { controller.abort(); }); client.destroy(); }, { once: true });
    win.addEventListener('pageshow', function (event) { if (event.persisted) client.invalidate(); });
    loadTopics(true);
  }
  return { productTag: productTag, productPath: productPath, plainText: plainText, normalizeTopic: normalizeTopic,
    contentForProduct: contentForProduct, validateDraft: validateDraft, createClient: createClient, mount: mount };
});
